/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
  * @class DashboardContent
  * @classdesc This Content child class provides content for the dashboard
  */
define([
	'./Content'
], function (Content) {

	const UNSUPPORTED_ERROR = 'Not supported.';

	class DashboardContent extends Content {

		initialize() {
			return Promise.resolve(this.getAPI());
		}

		getType() {
			return 'dashboard';
		}

		getContentInstance() {
			return undefined;
		}

		_getModel() {
			return this.boardModel;
		}

		_getModelItems() {
			// TODO: Once tied into the content hierarchy, this should return '[this.boardModel.layout]'
			return [];
		}

		createFeatureLoader() {
		}

		onAddItem(/*payload*/) {
		}

		onRemoveItem(/*payload*/) {
		}

		onChangeParent(/*payload*/) {
		}

		preRemoveItem(/*payload*/) {
		}

		// The following content api functions do not have an implementation yet, add as required
		removeChildContent(/*id, transactionToken*/) {
			throw new Error(UNSUPPORTED_ERROR);
		}

		removeContentReference(/*content*/) {
			throw new Error(UNSUPPORTED_ERROR);
		}

		addContentReference(/*content*/) {
			throw new Error(UNSUPPORTED_ERROR);
		}

		moveToContainer(/*newContainerInst*/) {
			throw new Error(UNSUPPORTED_ERROR);
		}

		moveContent(/*containerId, contentIdList, transactionToken, insertBeforeMap*/) {
			throw new Error(UNSUPPORTED_ERROR);
		}

		removeContent(/*id, transactionToken*/) {
			throw new Error(UNSUPPORTED_ERROR);
		}
	}
	return DashboardContent;
});
